module.exports = __webpack_public_path__ + "img/SC.f994e885.svg";